import { useState } from "react";
import classNames from "classnames";
import { ArrowIcon } from "@shared/ui/Icon/ui/Common/arrow-icon";
import { FixedAccordionProps } from "./types";
import classes from "./fixed-accordion.module.scss";

export const FixedAccordion = ({ title, content, expanded = false }: FixedAccordionProps) => {
    const [isOpen, setIsOpen] = useState(expanded);

    const handleClick = () => setIsOpen((prev) => !prev);

    return (
        <div className={classes.accordion}>
            <div className={classes.accordion__header} onClick={handleClick}>
                {title}
                <ArrowIcon
                    className={classNames(
                        classes.accordion__icon,
                        isOpen && classes["accordion__icon--rotated"]
                    )}
                />
            </div>
            {isOpen && <div className={classes.accordion__content}>{content}</div>}
        </div>
    );
};